import { atom } from "recoil";

export const playerPageDefaultState = {
		show: false,
		loaded: false,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		uid: 0,
		data: {},
		log: {
			loaded: false,
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
			data: [],
			type: 1,
			page: 0,
			min: 0,
			max: 999999999,
			limit: 20000,
			currentSearch: "",
		},
		bonuses: {
			sweepstakesActive: {
				sorting: {
					sortingColumn: {
						order: "",
						column: "",
					},
					isDescending: false,
				},
				currentSearch: "",
				currentSearchType: "",
				error: {
					text: "",
					code: 0,
					timestamp: 0,
				},
				pagination: {
					current: 1,
					total: 0,
					count: 0,
				},
				data: [],
				loaded: false,
			},
			sweepstakesHistory: {
				sorting: {
					sortingColumn: {
						order: "",
						column: "",
					},
					isDescending: false,
				},
				currentSearch: "",
				currentSearchType: "",
				error: {
					text: "",
					code: 0,
					timestamp: 0,
				},
				pagination: {
					current: 1,
					total: 0,
					count: 0,
				},
				data: [],
				loaded: false,
			},
			fortuneWheel: {
				sorting: {
					sortingColumn: {
						order: "",
						column: "",
					},
					isDescending: false,
				},
				currentSearch: "",
				error: {
					text: "",
					code: 0,
					timestamp: 0,
				},
				pagination: {
					current: 0,
					total: 0,
					count: 0,
				},
				data: [],
				loaded: false,
			},
			promocode: {
				sorting: {
					sortingColumn: {
						order: "",
						column: "",
					},
					isDescending: false,
				},
				currentSearch: "",
				error: {
					text: "",
					code: 0,
					timestamp: 0,
				},
				pagination: {
					current: 0,
					total: 0,
					count: 0,
				},
				data: [],
				loaded: false,
			},
			allPromocode: {
				sorting: {
					sortingColumn: {
						order: "",
						column: "",
					},
					isDescending: false,
				},
				currentOption: {},
				currentSearchType: "",
				currentSearch: "",
				error: {
					text: "",
					code: 0,
					timestamp: 0,
				},
				pagination: {
					current: 0,
					total: 0,
					count: 0,
				},
				data: [],
				loaded: false,
			},
			rain: {
				sorting: {
					sortingColumn: {
						order: "",
						column: "",
					},
					isDescending: false,
				},
				currentSearch: "",
				error: {
					text: "",
					code: 0,
					timestamp: 0,
				},
				pagination: {
					current: 0,
					total: 0,
					count: 0,
				},
				data: [],
				loaded: false,
			},
			achievementsActive: {
				sorting: {
					sortingColumn: {
						order: "",
						column: "",
					},
					isDescending: false,
				},
				currentSearch: "",
				currentSearchType: "",
				error: {
					text: "",
					code: 0,
					timestamp: 0,
				},
				pagination: {
					current: 1,
					total: 0,
					count: 0,
				},
				data: [],
				loaded: false,
			},
			achievementsHistory: {
				sorting: {
					sortingColumn: {
						order: "",
						column: "",
					},
					isDescending: false,
				},
				currentSearch: "",
				currentSearchType: "",
				error: {
					text: "",
					code: 0,
					timestamp: 0,
				},
				pagination: {
					current: 1,
					total: 0,
					count: 0,
				},
				data: [],
				loaded: false,
			}
		},
		freespins: {
			sorting: {
				sortingColumn: {
					order: "",
					column: "",
				},
				isDescending: false,
			},
			currentSearch: "",
			currentFilter: "all", // all, active, completed, expired
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
			pagination: {
				currentPage: 1,
				hasNext: false,
				hasPrevious: false,
				limit: 20,
				offset: 0,
				count: 0,
			},
			data: [],
			loaded: false,
		},
		sportsbookFreebets: {
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
			data: [],
			loaded: false,
		},
		gameLog: {
			pagination: {
				current: 1,
				total: 0,
			},
			currentSearch: "",
		},
		sorting: {
			sortingColumn: {
				sortingField: "",
			},
			isDescending: false,
		},
		pagination: {
			current: 1,
			total: 0,
		},
};

export const playerPageStore = atom({
	key: "playerPageStore",
	default: playerPageDefaultState,
});
